/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Expiration_HelpInputs */

const en_carrier_notices_expiration_help = /** @type {(inputs: Carrier_Notices_Expiration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous dates are disabled. A selected date stays visible through the end of that day.`)
};

const es_carrier_notices_expiration_help = /** @type {(inputs: Carrier_Notices_Expiration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fechas anteriores estan deshabilitadas. La fecha seleccionada permanece visible hasta el final de ese dia.`)
};

/**
* | output |
* | --- |
* | "Previous dates are disabled. A selected date stays visible through the end of that day." |
*
* @param {Carrier_Notices_Expiration_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_expiration_help = /** @type {((inputs?: Carrier_Notices_Expiration_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Expiration_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_expiration_help(inputs)
	return es_carrier_notices_expiration_help(inputs)
});